var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { key: _vm.$route.path, staticClass: "pb-10" },
    [
      _c("TabsWithRoutes", {
        staticClass: "mb-0.5",
        attrs: {
          routeTabs: _vm.routeTabs,
          navClass: "navParent",
          variant: "yellow",
        },
        scopedSlots: _vm._u(
          [
            {
              key: _vm.routes.ALL_EMPTY_VISITS,
              fn: function () {
                return [
                  _c("span", { staticClass: "mr-1" }, [_vm._v("Open visits")]),
                  _c("TabNotificationBubble", {
                    attrs: {
                      notification: _vm.emptyTotal,
                      gray: "",
                      medium: true,
                    },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: _vm.routes.ACCEPTED_VISITS,
              fn: function () {
                return [
                  _c("span", { staticClass: "mr-1" }, [_vm._v("Assigned")]),
                  _c("TabNotificationBubble", {
                    attrs: {
                      notification: _vm.assignedTotal,
                      gray: "",
                      medium: true,
                    },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: _vm.routes.COMPLETED_VISITS,
              fn: function () {
                return [
                  _c("span", { staticClass: "mr-1" }, [_vm._v("Completed")]),
                  _c("TabNotificationBubble", {
                    attrs: {
                      notification: _vm.completedTotal,
                      gray: "",
                      medium: true,
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _vm.dialog
        ? _c("ProjectModal", {
            attrs: { companyId: _vm.company.id, currentUser: _vm.currentUser },
            on: {
              close: function ($event) {
                _vm.dialog = false
              },
            },
          })
        : _vm._e(),
      _c("router-view", {
        attrs: {
          company: _vm.company,
          currentUser: _vm.currentUser,
          totalClient: _vm.totalClient,
          assignedTotal: _vm.assignedTotal,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }